import { Link } from '@reach/router';
import React, { useState } from 'react';
import ApplicationLogo from '../ApplicationLogo';
import { Button } from '../Button';
import { Section } from '../Section';
import AppState from 'js/stores/AppState';
import AppUser from "js/stores/AppUser";

export function Header({ dark = false, pageId, className }) {
  const [showNav, setShowNav] = useState(false);

  const toggleNavDropdown = () => setShowingNavDropdown(!showingNavDropdown);

  const handleLogin = event => {
    event.preventDefault();
    AppState.showLoginSignup('login');
  }

  return (
    <Section
      pad={false}
      className={`tw-flex tw-items-center tw-justify-between tw-py-4 md:tw-py-8 ${className}`}
    >
      <div className="tw-flex tw-items-center tw-justify-start tw-gap-4 md:tw-gap-8">
        <button
          onClick={() => setShowNav((prev) => !prev)}
          className={`tw-inline-flex tw-items-center tw-justify-center tw-border-none tw-bg-transparent tw-outline-none lg:tw-hidden ${dark ? 'tw-text-white' : 'tw-text-black'}`}
        >
          <svg
            className="tw-h-6 tw-w-6"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              className={!showNav ? 'tw-inline-flex' : 'tw-hidden'}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
            <path
              className={showNav ? 'tw-inline-flex' : 'tw-hidden'}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <div>
          <ApplicationLogo
            width={148}
            height={31.69}
            className="tw-hidden tw-text-secondary dark:tw-text-white md:tw-block"
          />
          <ApplicationLogo
            mini
            width={19}
            height={25}
            className="tw-block tw-text-secondary dark:tw-text-white md:tw-hidden"
          />
        </div>

        <div className={`tw-hidden md:tw-gap-8 lg:tw-flex ${dark ? 'tw-text-white' : 'tw-text-black'}`}>
          <Link to={'/seller'}>Seller</Link>
          <Link to={'/buyer'}>Buyer</Link>
          <Link to={'/secure-pay'}>SecurePay</Link>
        </div>
      </div>

      <div className={`tw-hidden tw-items-center tw-gap-4 md:tw-gap-8 lg:tw-flex ${dark ? 'tw-text-white' : 'tw-text-black'}`}>
        <div className="tw-flex tw-gap-2 tw-items-center">
          <img loading="lazy" src="/assets/images/Nigeria.png" alt="Nigeria" />
          <p>Nigeria</p>
        </div>
        <a href='/help-center' target="_blank">Help Center</a>
        {!AppUser.id && (
          <Button outline title={'Login'} onClick={handleLogin} />
        )}
        <Button title={'Start Selling'} href={'/create-link'} />
      </div>

      <div className="tw-flex tw-items-center tw-gap-4 md:tw-gap-8 lg:tw-hidden">
        {!AppUser.id && (
          <Button outline title={'Login'} className={`tw-border-0 tw-p-0 ${dark ? 'tw-text-white' : ''}`} onClick={handleLogin} />
        )}
        <Button href={'/create-link'} title={'Start Selling'} />
      </div>

      <div
        className={`tw-transform tw-flex-col tw-gap-8 tw-p-4 sm:tw-p-6 lg:tw-px-8 ${showNav ? 'tw-translate-x-0 tw-flex lg:tw-hidden' : 'tw-translate-x-full tw-hidden'} tw-fixed tw-inset-y-0 tw-right-0 tw-z-50 tw-w-64 tw-bg-white lg:tw-relative lg:tw-translate-x-0`}>
        <ApplicationLogo
          width={148}
          height={31.69}
          className="tw-text-secondary"
        />
        <Link to={'/seller'}>Seller</Link>
        <Link to={'/buyer'}>Buyer</Link>
        <Link to={'/secure-pay'}>SecurePay</Link>
        <Link to={'/help-center'}>Help Center</Link>
        <div className="tw-flex tw-gap-2 tw-items-center">
          <img loading="lazy" src="/assets/images/Nigeria.png" alt="Nigeria" />
          <p>Nigeria</p>
        </div>
        {!AppUser.id && (
          <Button outline title={'Login'} onClick={handleLogin} />
        )}
        <Button title={'Start Selling'} href={'/create-link'} />
      </div>
    </Section>
  );
}
